import { useState } from "react";

import { AddMoreButton, SectionTitle } from "@components";
import { AttachmentPosting } from "./AttachmentPosting";
import { NewAttachmentPosting } from "./NewAttachmentPosting";

import { AttachmentPostingType } from "@type/HRM/postings";

interface AttachmentPostingPropsType {
  attachmentPostingsInfo?: AttachmentPostingType[];
  changeAttachmentPostingsInfo?: any;
  removeAttachmentPostingInfo?: any;
  deleteAttachmentPostingRequest?: boolean;
}

export const AttachmentPostings = ({
  attachmentPostingsInfo,
  changeAttachmentPostingsInfo,
  removeAttachmentPostingInfo,
}: AttachmentPostingPropsType) => {
  const [newAttachmentPostingFormShow, setNewAttachmentPostingFormShow] =
    useState(false);
  const handleNewAttachmentPostingFormShow = (isShow: boolean) =>
    setNewAttachmentPostingFormShow(isShow);

  return (
    <div className="d-flex flex-column gap-8">
      <SectionTitle
        label="EMPLOYEE.POSTINGS_INFO.FORM.ATTACHMENT_POSTING_INFO.HEADING"
        size="lg"
        noBorder
      />

      {attachmentPostingsInfo?.map((attachmentPosting, index) => (
        <AttachmentPosting
          key={index}
          attachmentPostingInfo={attachmentPosting}
          changeAttachmentPostingsInfo={changeAttachmentPostingsInfo}
          removeAttachmentPostingInfo={removeAttachmentPostingInfo}
        />
      ))}

      {newAttachmentPostingFormShow ? (
        <NewAttachmentPosting
          handleNewAttachmentPostingFormShow={
            handleNewAttachmentPostingFormShow
          }
          changeAttachmentPostingsInfo={changeAttachmentPostingsInfo}
        />
      ) : (
        <AddMoreButton
          label="EMPLOYEE.POSTINGS_INFO.FORM.ATTACHMENT_POSTING_INFO.ADD_MORE_BUTTON"
          clickAction={() => handleNewAttachmentPostingFormShow(true)}
        />
      )}
    </div>
  );
};

export default AttachmentPostings;
